var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Icon from './Icon';
/** Inspiration for this file came from material icons here -
 *  https://github.com/mui-org/material-ui/blob/4d50a9ed6a7c2007b9e5061d0842f38df191cfb2/packages/material-ui/src/utils/createSvgIcon.js
 * @param path the svg content that forms the icon's appearance.
 *  NOTE: In order for Icon component's `color` and `htmlColor` attributes to work, do NOT set the `fill` attribute on the path element
 * @param displayName the name of the svg icon component that is created
 * @return the memoized svg icon component
 * */
export default function createSvgIcon(path, displayName) {
    var Component = function (props, ref) { return (React.createElement(Icon, __assign({ "data-testid": displayName + "Icon", ref: ref }, props), path)); };
    Component.displayName = displayName + "Icon";
    Component.muiName = Icon.displayName;
    var MemoComponent = React.memo(React.forwardRef(Component));
    MemoComponent.displayName = displayName + "Icon";
    return MemoComponent;
}
